<template>
  <page-wrapper ref="pageEl" title="รายการสินค้า">
    <div class="sap-mm-po-vender-report">
      <vue-tabs
        v-model="tabDirect"
        class="child-component"
        active-tab-color="#d3d0cf"
      >
        <v-tab title="ซื้อใหม่">
          <appointment-product-waiting-fulfill
            class="mt-3"
            @reloadAppointmentDashboardPage="
              isReloadAppointmentDashboardPage = true
            "
          ></appointment-product-waiting-fulfill>
        </v-tab>
        <v-tab title="เสร็จสิ้น">
          <appointment-dashboard-page
            :is-product-page="true"
            :is-reload-appointment-dashboard-page="isReloadAppointmentDashboardPage"
            @reloadAppointmentDashboardPage="
              isReloadAppointmentDashboardPage = false
            "
          ></appointment-dashboard-page>
        </v-tab>
      </vue-tabs>
    </div>
  </page-wrapper>
</template>

<script>
import PageWrapper from "@/lib/components/PageWrapper";
import AppointmentProductWaitingFulfill from "../components/AppointmentProductWaitingFulfill";
import AppointmentDashboardPage from "./AppointmentDashboardPage";

export default {
  name: 'AppointmentProductDashboardPage',
  components: {
    PageWrapper,
    AppointmentProductWaitingFulfill,
    AppointmentDashboardPage,
  },
  data() {
    return {
      isReloadAppointmentDashboardPage: false,
      tabDirect: null,
    };
  },
  watch: {
    tabDirect(newValue) {
      if (newValue && newValue !== this.$route.query.tab) {
        const route = {
          name: this.$route.name,
          query: { ...this.$route.query, tab: newValue },
        };

        this.$router.push(route);
      }
    },
  },
  created() {
    if (this.$route.query.tab && this.$route.query.tab !== "ซื้อใหม่") {
      this.tabDirect = this.$route.query.tab;
    }
  },
};
</script>

<style lang="scss" scoped>
@import "~@/lib/scss/variables";

.sap-mm-po-vender-report {
  padding-left: 30px;
  padding-top: 30px;
  font-size: 20px;
}
</style>